<template>
  <div>
    <Top />
    <div class="questionnaire">
      <h3>{{ details.survey_title }}</h3>
      <h6 v-html="details.survey_desc"></h6>
      <div class="questionnaire-box">
        <div
          class="list"
          v-for="(item, index) in details.detail"
          :key="item.id"
          :id="'id' + index"
        >
          <div class="items">
            <div class="title" v-html="item.title"></div>
            <!-- 单选 -->
            <div class="type" v-if="item.type == 0">
              <el-radio
                v-model="item.answerType"
                :label="radios.text"
                v-for="(radios, radioi) in item.options"
                :key="radioi"
                >{{ radios.text }}
                <!-- 其他另选 -->
                <el-input
                  v-model="radios.otherValue"
                  size="mini"
                  v-if="radios.hasInput == 'true'"
                ></el-input>
                <!-- <input
                  type="text"
                  class="input"
                  v-if="radios.hasInput == 'true'"
                  v-model="radios.otherValue"
                /> -->
              </el-radio>
            </div>
            <!-- 多选 -->
            <div class="type" v-else-if="item.type == 1">
              <el-checkbox-group v-model="item.answerType">
                <el-checkbox
                  v-for="(checks, checki) in item.options"
                  :key="checki"
                  :label="checks.text"
                  >{{ checks.text }}
                  <!-- 其他另选 -->
                  <el-input
                    v-if="checks.hasInput == 'true'"
                    v-model="checks.otherValue"
                    size="mini"
                  ></el-input>
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <!-- 问答 -->
            <div class="type" v-else-if="item.type == 2">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="item.answerType"
                resize="none"
              >
              </el-input>
            </div>

            <p style="color: red" v-if="item.flag">この質問は必須です</p>
          </div>
        </div>
        <div class="btn">
          <el-button type="primary" @click="submit"> 提出 </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import {
  surveyDetail,
  surveyAnswer,
  get_token,
} from "../../api/API/questionnaire";
export default {
  data() {
    return {
      checked: true,
      radio: 0,
      textarea: "",
      details: {
        detail: [],
        survey_desc: "",
        survey_title: "",
      },
      token: "",
    };
  },
  components: {
    Top,
  },
  created() {
    let userInfo = this.$store.state.userInfo;
    console.log(this.$store.state.userInfo);
    if (
      userInfo == null ||
      userInfo == undefined ||
      userInfo == false ||
      userInfo == ""
    ) {
      let url = this.$route.fullPath;
      this.$store.commit("toPage", url);
      this.$router.push("/login");
      return false;
    }
    console.log(userInfo.data);
    let datas = {
      data: {
        user_id: userInfo.data.id ? userInfo.data.id : userInfo.data.uid,
        user_name: userInfo.data.realname,
      },
    };
    get_token(datas).then((res) => {
      this.token = res.data;
      this.surveyDetail();
    });
  },
  methods: {
    surveyDetail() {
      let datas = {
        questionnaire_id: this.$route.query.id,
        keywords_search: "",
        page: 1,
        page_size: 20,
        token: this.token,
      };
      surveyDetail(datas).then((res) => {
        this.details = res.data[0];

        this.details.survey_desc = this.details.survey_desc.replace(
          /\n/g,
          "<br/>"
        );
        this.details.detail.forEach((item, index) => {
          item.title = index + 1 + "、" + item.title.replace(/\n/g, "<br/>");
          item.flag = true;
        });
        console.log(this.details.detail);
      });
    },
    // 提交
    submit() {
      let flag = true;
      this.details.detail.forEach((item) => {
        if (item.answerType == "" || item.answerType == false) {
          item.flag = true;
        } else {
          item.flag = false;
        }
      });
      this.$forceUpdate();
      for (let i = 0; i < this.details.detail.length; i++) {
        if (
          this.details.detail[i].answerType == "" ||
          this.details.detail[i].answerType == false
        ) {
          flag = false;
          window.scrollTo(
            document.querySelector("#id" + i).offsetTop,
            document.querySelector("#id" + i).offsetTop
          );
          break;
        }
      }

      if (!flag) {
        return this.$message.error("この質問は必須です");
      }
      let datas = {
        user_token: this.token,
        questionnaire_id: this.$route.query.id,
        answer: [],
        detail: [],
        type: "xiaojian",

        answer: [],
      };
      this.details.detail.forEach((item) => {
        item.value =
          item.answerType instanceof Array
            ? item.answerType
            : [item.answerType];

        if (item.options) {
          item.value.forEach((val, vai) => {
            item.options.forEach((opti) => {
              if (opti.hasInput == "true" && opti.text == val) {
                item.value[vai] = opti.otherValue;
              }
            });
          });
        }
        datas.answer.push({
          id: item.id,
          answer: item.value,
        });
      });
      datas.detail = JSON.stringify(datas.answer);
      surveyAnswer(datas).then((res) => {
        if (res.code != 1) return this.$message.error(res.message);

        this.$confirm(
          "アンケート調査にご協力頂きありがとうございました。詳細確認後、担当者を配属させていただきます。宜しくお願い致します。",
          {
            confirmButtonText: "确定",

            type: "success",
            center: true,
          }
        )
          .then(() => {
            this.$router.push("/");
          })
          .catch(() => {
            this.$router.push("/");
          });
      });
    },
  },
};
</script>
<style >
body {
  background-color: #f5f5f5;
}
</style>
<style lang='scss' scoped>
.questionnaire {
  margin: 30px auto;
  width: 1000px;
  padding: 20px;
  font-size: 16px;

  h3 {
    text-align: center;
    font-size: 25px;
    font-weight: 700;
  }
  h6 {
    // text-align: center;
    margin: 30px 0;
  }
  .questionnaire-box {
    padding-bottom: 30px;
    .list {
      margin-bottom: 30px;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 20px;
      border-radius: 20px;
      .title {
        font-size: 20px;
      }
      .type {
        margin: 20px;
      }
    }
    .btn {
      text-align: center;
    }
    /deep/.el-input__inner {
      width: 160px;
      margin-bottom: 20px;
    }
  }
}
</style>